import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { BiBuildingHouse } from "react-icons/bi";

const MetricCard = ({ children, ...props }) => (
  <Card
    sx={{
      borderRadius: "8px",
      backgroundColor: "#F9FAFB",
      padding: "16px",
      textAlign: "center",
      boxShadow: "none",
      flex: 1,
      ...props.sx,
    }}
  >
    {children}
  </Card>
);

const VillaProject = ({ bidDetails, metrics }) => {
  return (
    <Card
      sx={{
        borderRadius: "12px",
        boxShadow: "none",
        margin: "1vh 0",
        border: "1px solid #E5E7EB",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            marginBottom: "1vh",
            letterSpacing: "0",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "16px",
          }}
        >
          <BiBuildingHouse color="#4D6BF6" size={20} />
          {bidDetails.project_type} Project
        </Typography>

        <div style={{ display: "flex", gap: "16px", padding: "1vh 0" }}>
          <MetricCard>
            <Typography
              variant="h5"
              color="primary"
              sx={{ fontWeight: "bold", color: "#4D6BF6" }}
            >
              {metrics.rooms}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Rooms
            </Typography>
          </MetricCard>

          <MetricCard>
            <Typography
              variant="h5"
              color="primary"
              sx={{ fontWeight: "bold", color: "#fa832e" }}
            >
              {metrics.inclusions}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Inclusions
            </Typography>
          </MetricCard>

          <MetricCard>
            <Typography
              variant="h5"
              color="primary"
              sx={{ fontWeight: "bold", color: "#16a249" }}
            >
              {metrics.totalItems}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total Items
            </Typography>
          </MetricCard>

          <MetricCard>
            <Typography
              variant="h5"
              color="primary"
              sx={{ fontWeight: "bold", color: "#0d0d0e" }}
            >
              {metrics.priced}/{metrics.totalItems}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Priced
            </Typography>
          </MetricCard>
        </div>
      </CardContent>
    </Card>
  );
};

export default VillaProject;
